import { Box, Flex } from "@chakra-ui/layout";
import { GetStaticProps } from "next";
import { useState } from "react";
import AppContainer from "src/common/AppContainer";
import PageHeading from "src/common/PageHeading";
import Topic from "src/common/Topic";
import TopicRequestModal from "src/common/TopicRequestModal";
import Page from "src/seo/Page";
import topicsService from "src/server/services/topics";
import { Hyperlink, P } from "src/typography/typography";

function Topics({ topics }) {
  const [isOpen, setIsOpen] = useState(false)
  const onClose = () => setIsOpen(false)

  return (
    <Page
      name={`Heavy industry topics`}
      description={`${topics.map(t => t.name).join(', ')} projects`}
      path={`/topics`}
    >
      <AppContainer mb={24}>
        <PageHeading mt='base' mb={4}>
          Topics
        </PageHeading>
        <P mb='base'>
          Projectink specialized in heavy industries.
          We curate the topics to stay focused and relevant.
          If none of these apply to you, you can <Hyperlink onClick={() => setIsOpen(true)}>click here</Hyperlink> to request a topic.
        </P>
        <Flex flexWrap='wrap'>
          {topics.map(topic => (
            <Box w={['51%', '51%', '25%', '25%']} pr='base'>
              <Topic topic={topic} mb={4} />
            </Box>
          ))}
        </Flex>
        <TopicRequestModal isOpen={isOpen} onClose={onClose} />
      </AppContainer>
    </Page>
  )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const topics = await topicsService.getAll()
  return {
    props: {
      topics,
    },
  }
}

export default Topics
